export const toolbarStyles: React.CSSProperties = {
  flexDirection: 'row',
  justifyContent: 'end',
  marginBottom: '10px',
};
